import React from "react";
import * as styles from "./ShipFacilityModal.module.scss";
import {
  ResponsiveSlideshow,
  SlideshowItemImage
} from "components/Slideshow/Slideshow";
import { BlockContent } from "components/BlockContent";

export interface ContentWithSlideshowProps {
  images?: SlideshowItemImage[];
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  description: any;
}

const ContentWithSlideshow: React.FC<ContentWithSlideshowProps> = ({
  images,
  title,
  description
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.leftSide}>
        {images && (
          <ResponsiveSlideshow
            items={images}
            variant="gray"
            fullscreen={false}
          />
        )}
      </div>
      <div className={styles.rightSide}>
        <h3>{title}</h3>
        <BlockContent blocks={description} />
      </div>
    </div>
  );
};

export default ContentWithSlideshow;
